import { JobsStatus } from "../constants/Jobs";

type JobLike = { attributes: { globalid?: string | null; status?: number | null } };

/** Distinct, non-empty ids in first-seen order. */
export const uniqueIds = (ids: (string | null | undefined)[]): string[] => [
    ...new Set(ids.filter((id): id is string => !!id)),
];

/**
 * Keeps the jobs that block or warn about a new job on the object: every QA1 job, and
 * the Plan jobs that belong to the active version. Plan jobs from other versions are
 * someone else's draft and do not count. Globalid casing is ignored since the ids come
 * from different tables.
 */
export const filterJobsForActiveVersion = <T extends JobLike>(jobs: T[], planJobIdsForVersion: string[]): T[] => {
    const planIds = new Set(planJobIdsForVersion.map((id) => id.toUpperCase()));
    return jobs.filter((job) => {
        if (job.attributes.status === JobsStatus.QA1) return true;
        if (job.attributes.status !== JobsStatus.Plan) return false;
        return planIds.has((job.attributes.globalid ?? "").toUpperCase());
    });
};
